import { RootState } from "../reducers";

export const getPortalConfigSelector = (state: RootState) => state.portalConfig.config;
